import { render, staticRenderFns } from "./after_sale.vue?vue&type=template&id=25f03992&scoped=true"
import script from "./after_sale.vue?vue&type=script&lang=js"
export * from "./after_sale.vue?vue&type=script&lang=js"
import style0 from "./after_sale.vue?vue&type=style&index=0&id=25f03992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f03992",
  null
  
)

export default component.exports